const BASE_URL = 'https://perufc-backend-dev-458325760045.us-central1.run.app/api/v1';

export const environment = {
  production: false,
  apiUrl: `${BASE_URL}/public`,
  authUrl: `${BASE_URL}/auth`,
  paymentsUrl: `${BASE_URL}/payments`,
};
